// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"67f599b8","239":"15838d98","389":"20e20fbd","408":"378d29bd","439":"f2848f4a","455":"075efd40","525":"11ce2d09","620":"c39f356e","700":"d747d805","771":"e0684443","938":"404b3500","977":"1b5453ab"}[chunkId] + ".chunk.js";
};